import styled from 'styled-components';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

const StyledQuestionTitle = styled.span`
  display: inline-block;
  ${media.mobile`
    margin: 6px 0 8px;
    ${typeStyle['font-13']};
  `}
  ${media.desktop`
    margin: 16px 0 8px;
    ${typeStyle['font-14']};
  `}
`;

const StyledLabel = styled.label`
  display: flex;
  align-items: flex-end;
  margin-bottom: 9px;
  ${typeStyle['font-13']};
`;

const StyledInput = styled.input`
  display: grid;
  width: 14px;
  height: 14px;
  margin-right: 11px;
  transform: translateY(-0.075em);
  background-color: transparent;
  place-content: center;
  appearance: none;
  border: 0.15em solid ${theme.color.white};
  border-radius: 50%;

  &::before {
    content: '';
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em white;
  }

  &:checked::before {
    transform: scale(1);
  }
`;

export { StyledQuestionTitle, StyledLabel, StyledInput };
